import {
  Box,
  Button,
  FileButton,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput, DateTimePicker } from "@mantine/dates";
import {
  IconCalendar,
  IconCheck,
  IconClock,
  IconUpload,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { modals } from "@mantine/modals";
import { useDisclosure } from "@mantine/hooks";

const UploadPriceList = ({
  method,
  data,
  onSuccess,
}: {
  method: string;
  data?: any;
  onSuccess: any;
}) => {
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [file, setFile] = useState<File | null>(null);
  const [scheduleDateTime, setScheduleDateTime] = useState<string>(
    method === "EDIT" ? data?.scheduleDate : ""
  );
  const [timeSchedule, setTimeSchedule] = useState<string>(
    method === "EDIT" ? data?.scheduleDate?.split("T")[1]?.slice(0, 5) : ""
  );

  const [isValid, setIsValid] = useState(true);
  const [description, setDescription] = useState<string>(
    method === "EDIT" ? data?.description : ""
  );

  const handleChange = (e: any) => {
    const inputValue = e.currentTarget.value.replace(/\s+/g, "");
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    setTimeSchedule(inputValue);
    if (inputValue.length > 0) {
      setIsValid(regex.test(inputValue));
    } else {
      setIsValid(true);
    }
  };

  const mergeTime = (dateString: string, timeString: string) => {
    const date = new Date(dateString);
    const [hours, minutes] = timeString.split(":").map(Number);

    // Gán lại giờ, phút theo timeSchedule
    date.setUTCHours(hours, minutes, 0, 0);

    return date.toISOString();
  };

  const handleSubmit = async () => {
    open();
    setLoadingButton(true);
    if (!file) {
      NotificationExtension.Fails("Vui lòng chọn File cập nhật !");
      setLoadingButton(false);
      close();
      return;
    }

    const formData = new FormData();
    formData.append("FormFile", file);
    formData.append(
      "ScheduleDateTime",
      mergeTime(
        new Date(
          new Date(scheduleDateTime).getTime() + 7 * 3600 * 1000
        )?.toISOString(),
        timeSchedule
      )
    );
    formData.append("Description", description);

    const res = await repositoryDelivery.post<MessageResponse<boolean>>(
      "/api/v1/FileSchedule/schedule-price-list-import",
      formData
    );
    if (res && res.success) {
      NotificationExtension.Success("Lập lịch cập nhật bảng giá thành công !");
      setTimeout(() => {
        modals.closeAll();
        onSuccess();
      }, 1000);
      close();
    } else {
      setLoadingButton(false);
      NotificationExtension.Fails(res?.message);
      close();
    }
  };

  const handleUpdate = async () => {
    setLoadingButton(true);
    const res = await repositoryDelivery.put<MessageResponse<any>>(
      `/api/v1/FileSchedule/update-job/${data?.id}`,
      {
        newScheduleDateTime: mergeTime(
          new Date(
            new Date(scheduleDateTime).getTime() + 7 * 3600 * 1000
          )?.toISOString(),
          timeSchedule
        ),
        description: description,
      }
    );

    if (res && res.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      setTimeout(() => {
        modals.closeAll();
        onSuccess();
      }, 1000);
    } else {
      setLoadingButton(false);
      NotificationExtension.Fails(res?.message);
    }
  };

  return (
    <Box component="form" m={"5px 0px"} w={"45vw"} maw={700}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý ...</Title>
            </Flex>
          ),
        }}
      />
      <Grid>
        {method === "CREATE" ? (
          <Grid.Col span={{ base: 12, xs: 12, lg: 6 }}>
            <FileButton onChange={setFile}>
              {(props) => (
                <TextInput
                  label="File"
                  placeholder="Chọn file cập nhật"
                  rightSection={<IconUpload size={16} />}
                  value={file ? file?.name : ""}
                  readOnly
                  withAsterisk
                  {...props}
                />
              )}
            </FileButton>
          </Grid.Col>
        ) : (
          <></>
        )}
        <Grid.Col span={method === "CREATE" ? { base: 12, xs: 12, lg: 6 } : 12}>
          <Flex w={"100%"} justify={"space-between"} align={"end"} gap={"md"}>
            <DatePickerInput
              label="Thời gian cập nhật"
              placeholder="Ngày cập nhật"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                scheduleDateTime && scheduleDateTime.length > 0
                  ? new Date(scheduleDateTime)
                  : null
              }
              minDate={new Date()}
              onChange={(e) =>
                setScheduleDateTime(e ? new Date(e)?.toISOString() : "")
              }
              rightSection={<IconCalendar size={16} />}
              withAsterisk
              w={"50%"}
            />
            <TextInput
              placeholder="Giờ cập nhật (hh:mm)"
              w={"50%"}
              value={timeSchedule}
              rightSection={<IconClock size={16} />}
              onChange={handleChange}
              error={
                !isValid ? "Định dạng không hợp lệ. VD: 09:00, 18:00" : null
              }
            />
          </Flex>
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label="Mô tả"
            placeholder="Nhập mô tả"
            value={description}
            onChange={(e) => setDescription(e.currentTarget.value)}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"end"} mt={10}>
        <Button
          leftSection={<IconCheck size={16} />}
          onClick={() => {
            if (method === "CREATE") {
              handleSubmit();
            } else if (method === "EDIT") {
              handleUpdate();
            }
          }}
          disabled={loadingButton}
          loading={loadingButton}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default UploadPriceList;
